/* Alcami header: Shop panel (hover / click / keyboard, live preview of the tile under the pointer),
   language + currency switcher, header that hides while scrolling down and returns on scroll up,
   rotating announcement bar. Markup: snippets/alcami-header-*.liquid, sections/alcami-announce.liquid. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hoverMQ = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: true };
  var desktopMQ = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: true };

  function headerSection() { return document.querySelector('.shopify-section-header'); }

  /* ---------------------------------------------------------------- overlay */
  var overlay = null;
  function getOverlay() {
    if (overlay && document.body.contains(overlay)) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'alc-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.addEventListener('click', function () { closeAllMenus(); closeAllLocales(); });
    document.body.appendChild(overlay);
    return overlay;
  }
  function setOverlay(on) {
    var o = getOverlay();
    var sec = headerSection();
    if (sec) o.style.top = Math.max(0, Math.round(sec.getBoundingClientRect().bottom)) + 'px';
    o.classList.toggle('is-on', !!on);
    document.documentElement.classList.toggle('alc-menu-open', !!on);
  }

  /* ---------------------------------------------------------------- Shop panel */
  var menus = [];
  function closeAllMenus(except) {
    menus.forEach(function (m) { if (m !== except) m.close(true); });
    if (!except) setOverlay(false);
  }

  function MenuItem(item) {
    this.item = item;
    this.trigger = item.querySelector('[data-alc-menu-trigger]');
    this.panel = item.querySelector('[data-alc-menu-panel]');
    this.isOpen = false;
    this.openTimer = 0;
    this.closeTimer = 0;
    this.openedAt = 0;
    this.preview = this.panel && this.panel.querySelector('[data-alc-preview]');
    this.bind();
  }
  MenuItem.prototype.open = function (focusFirst) {
    clearTimeout(this.closeTimer);
    if (this.isOpen) return;
    closeAllMenus(this);
    closeAllLocales();
    this.isOpen = true;
    this.openedAt = Date.now();
    this.panel.hidden = false;
    // next frame so the transition runs from the closed state
    var self = this;
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (self.isOpen) self.item.classList.add('is-open'); }); });
    this.trigger.setAttribute('aria-expanded', 'true');
    setOverlay(true);
    showHeader();
    if (focusFirst) {
      var first = this.panel.querySelector('a, button');
      if (first) setTimeout(function () { first.focus(); }, 30);
    }
  };
  MenuItem.prototype.close = function (silent) {
    clearTimeout(this.openTimer);
    if (!this.isOpen) return;
    this.isOpen = false;
    this.item.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    var self = this;
    setTimeout(function () { if (!self.isOpen) { self.panel.hidden = true; self.resetPreview(); } }, reduceMotion ? 0 : 220);
    if (!silent) setOverlay(false);
  };
  MenuItem.prototype.bind = function () {
    var self = this;
    if (!this.trigger || !this.panel) return;

    this.item.addEventListener('mouseenter', function () {
      if (!hoverMQ.matches) return;
      clearTimeout(self.closeTimer);
      var anyOpen = menus.some(function (m) { return m.isOpen; });
      self.openTimer = setTimeout(function () { self.open(false); }, anyOpen ? 0 : 90);
    });
    this.item.addEventListener('mouseleave', function () {
      if (!hoverMQ.matches) return;
      clearTimeout(self.openTimer);
      self.closeTimer = setTimeout(function () { self.close(); }, 220);
    });

    this.trigger.addEventListener('click', function (e) {
      // touch or keyboard: first activation opens the panel, the panel has the "Shop all" link.
      // mouse: hover already opened it, so a click follows the link.
      var justOpened = Date.now() - self.openedAt < 350;
      if (!self.isOpen) { e.preventDefault(); self.open(e.detail === 0); return; }
      if (justOpened && !hoverMQ.matches) { e.preventDefault(); }
    });
    this.trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); self.open(true); }
      if (e.key === 'Escape' && self.isOpen) { e.preventDefault(); self.close(); }
    });
    this.panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.close(); self.trigger.focus(); }
    });
    this.item.addEventListener('focusout', function (e) {
      if (!self.isOpen) return;
      var to = e.relatedTarget;
      if (to && !self.item.contains(to)) self.close();
    });

    // live preview: the feature card shows the tile under the pointer
    if (this.preview) {
      var tiles = this.panel.querySelectorAll('[data-alc-tile]');
      Array.prototype.forEach.call(tiles, function (t) {
        var show = function () { self.showTile(t); };
        t.addEventListener('mouseenter', show);
        t.addEventListener('focus', show);
      });
      var tilesWrap = this.panel.querySelector('.alc-tiles');
      if (tilesWrap) tilesWrap.addEventListener('mouseleave', function () {
        clearTimeout(self.prevTimer);
        self.prevTimer = setTimeout(function () { self.resetPreview(); }, 260);
      });
    }
  };
  MenuItem.prototype.swapPreview = function (d) {
    var p = this.preview;
    if (!p) return;
    var img = p.querySelector('.alc-preview__img');
    var set = function () {
      p.setAttribute('href', d.href);
      p.querySelector('[data-alc-preview-eyebrow]').textContent = d.eyebrow || '';
      p.querySelector('[data-alc-preview-title]').textContent = d.title || '';
      p.querySelector('[data-alc-preview-text]').textContent = d.text || '';
      p.querySelector('[data-alc-preview-cta]').textContent = d.cta || '';
      p.classList.toggle('is-product', !!d.product);
      if (img) {
        if (d.img) {
          if (img.dataset.src0 === undefined) { img.dataset.src0 = img.getAttribute('src') || ''; img.dataset.srcset0 = img.getAttribute('srcset') || ''; }
          if (d.restore) {
            if (img.dataset.srcset0) img.setAttribute('srcset', img.dataset.srcset0); else img.removeAttribute('srcset');
            img.src = img.dataset.src0;
          } else {
            img.removeAttribute('srcset');
            img.src = d.img;
          }
          img.hidden = false;
        } else {
          img.hidden = true;
        }
      }
      p.classList.remove('is-swapping');
    };
    clearTimeout(this.prevTimer);
    if (this.previewKey === d.key) return;
    this.previewKey = d.key;
    if (reduceMotion) { set(); return; }
    p.classList.add('is-swapping');
    var token = d.key;
    var self = this;
    var go = function () { if (self.previewKey === token) setTimeout(set, 90); };
    if (d.img && !d.restore) { var pre = new Image(); pre.onload = go; pre.onerror = go; pre.src = d.img; } else { go(); }
  };
  MenuItem.prototype.showTile = function (t) {
    clearTimeout(this.prevTimer);
    this.swapPreview({
      key: t.getAttribute('href'),
      href: t.getAttribute('href'),
      img: t.getAttribute('data-img'),
      eyebrow: t.getAttribute('data-price') || '',
      title: t.getAttribute('data-title') || '',
      text: t.getAttribute('data-tag') || '',
      cta: (this.preview && this.preview.getAttribute('data-shop-label')) || 'Shop now',
      product: true
    });
  };
  MenuItem.prototype.resetPreview = function () {
    var p = this.preview;
    if (!p) return;
    this.swapPreview({
      key: '__promo',
      href: p.getAttribute('data-href'),
      img: p.getAttribute('data-img'),
      eyebrow: p.getAttribute('data-eyebrow'),
      title: p.getAttribute('data-title'),
      text: p.getAttribute('data-text'),
      cta: p.getAttribute('data-cta'),
      restore: true,
      product: false
    });
  };

  function initMenus(root) {
    (root || document).querySelectorAll('[data-alc-menu]').forEach(function (item) {
      if (item.__alcMenu) return;
      item.__alcMenu = new MenuItem(item);
      menus.push(item.__alcMenu);
    });
  }

  /* ---------------------------------------------------------------- language + currency */
  var locales = [];
  function closeAllLocales(except) {
    locales.forEach(function (l) { if (l !== except) l.close(); });
  }
  function Locale(el) {
    this.el = el;
    this.btn = el.querySelector('[data-alc-locale-toggle]');
    this.panel = el.querySelector('[data-alc-locale-panel]');
    this.isOpen = false;
    var self = this;
    el.querySelectorAll('[data-alc-country]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        el.classList.add('is-busy');
        if (sel.form.requestSubmit) sel.form.requestSubmit(); else sel.form.submit();
      });
    });
    el.querySelectorAll('.alc-locale__pill').forEach(function (b) {
      b.addEventListener('click', function () { el.classList.add('is-busy'); });
    });
    if (!this.btn || !this.panel) return;
    this.btn.addEventListener('click', function (e) { e.preventDefault(); self.isOpen ? self.close() : self.open(); });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.isOpen) { self.close(); self.btn.focus(); } });
    el.addEventListener('focusout', function (e) { var to = e.relatedTarget; if (self.isOpen && to && !el.contains(to)) self.close(); });
  }
  Locale.prototype.open = function () {
    closeAllMenus();
    closeAllLocales(this);
    this.isOpen = true;
    this.panel.hidden = false;
    var self = this;
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (self.isOpen) self.el.classList.add('is-open'); }); });
    this.btn.setAttribute('aria-expanded', 'true');
    showHeader();
    var first = this.panel.querySelector('.alc-locale__pill.is-active, .alc-locale__pill, select');
    if (first) setTimeout(function () { first.focus(); }, 30);
  };
  Locale.prototype.close = function () {
    if (!this.isOpen || !this.btn) return;
    this.isOpen = false;
    this.el.classList.remove('is-open');
    this.btn.setAttribute('aria-expanded', 'false');
    var self = this;
    setTimeout(function () { if (!self.isOpen) self.panel.hidden = true; }, reduceMotion ? 0 : 180);
  };
  function initLocales(root) {
    (root || document).querySelectorAll('[data-alc-locale]').forEach(function (el) {
      if (el.__alcLocale) return;
      el.__alcLocale = new Locale(el);
      locales.push(el.__alcLocale);
    });
  }
  document.addEventListener('click', function (e) {
    locales.forEach(function (l) { if (l.isOpen && !l.el.contains(e.target)) l.close(); });
  });

  /* ---------------------------------------------------------------- hide on scroll down, show on scroll up */
  var lastY = window.pageYOffset || 0;
  var hidden = false;
  var ticking = false;
  function wrapper() { return document.querySelector('.alc-hdr'); }
  function autohideOn() { var w = wrapper(); return !!(w && w.classList.contains('alc-hdr--autohide')); }
  function somethingOpen() {
    var b = document.body;
    if (menus.some(function (m) { return m.isOpen; })) return true;
    if (locales.some(function (l) { return l.isOpen; })) return true;
    if (document.querySelector('.shopify-section-header details[open]')) return true;
    return b.classList.contains('overflow-hidden') || b.classList.contains('open_cart_drawer') || b.classList.contains('mini-cart--open') ||
      document.documentElement.classList.contains('menu-drawer--open') || b.classList.contains('menu-drawer--open') || b.classList.contains('menu-mobile--open');
  }
  function syncOffsets() {
    var sec = headerSection();
    if (!sec) return;
    var h = sec.offsetHeight;
    document.documentElement.style.setProperty('--alc-hh', h + 'px');
    // where the header's bottom edge rests once any slide finishes: sticky at 0, or lower while the
    // announcement bar above it is still on screen. Used by the phone menu and the premium buy box gallery.
    var prev = sec.previousElementSibling;
    var natural = prev ? prev.getBoundingClientRect().bottom : 0;
    var top = hidden ? 0 : Math.round(Math.max(0, natural) + h);
    if (top > 260) top = 0;
    document.querySelectorAll('.apm-buy').forEach(function (el) { el.style.setProperty('--apm-top', top + 'px'); });
    document.documentElement.style.setProperty('--alc-header-bottom', top + 'px');
  }
  function setHidden(on) {
    var sec = headerSection();
    if (!sec || hidden === on) return;
    hidden = on;
    sec.classList.toggle('alc-hdr-hidden', on);
    syncOffsets();
  }
  function showHeader() { setHidden(false); }
  function onScroll() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var sec = headerSection();
    if (!sec) return;
    sec.classList.toggle('alc-hdr-scrolled', y > 8 && sec.getBoundingClientRect().top <= 0.5);
    if (!autohideOn() || somethingOpen()) { setHidden(false); lastY = y; syncOffsets(); return; }
    var dy = y - lastY;
    // where the header sits before it sticks (a sticky element's offsetTop moves with it)
    var prev = sec.previousElementSibling;
    var start = prev ? Math.max(0, prev.getBoundingClientRect().bottom + y) : 0;
    var past = y > start + sec.offsetHeight + 120;
    if (dy > 6 && past) setHidden(true);
    else if (dy < -6 || !past) setHidden(false);
    if (Math.abs(dy) > 6) lastY = y;
    syncOffsets();
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  window.addEventListener('resize', function () { syncOffsets(); if (!desktopMQ.matches) closeAllMenus(); }, { passive: true });
  // drawers, cart and search open from inside the header: keep it in view while they are open
  new MutationObserver(function () { if (hidden && somethingOpen()) setHidden(false); })
    .observe(document.body, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('toggle', function (e) { if (e.target && e.target.open && hidden) setHidden(false); }, true);

  /* ---------------------------------------------------------------- phone menu: tabs, swipe, row animation */
  function PhoneMenu(el) {
    this.el = el;
    this.tabs = Array.prototype.slice.call(el.querySelectorAll('[data-alc-mtab]'));
    this.panels = Array.prototype.slice.call(el.querySelectorAll('[data-alc-mpanel]'));
    this.body = el.querySelector('[data-alc-mbody]');
    this.details = el.closest('details');
    this.def = el.getAttribute('data-default') || 'shop';
    var self = this;
    this.tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { self.select(t.getAttribute('data-alc-mtab'), false); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % self.tabs.length;
        if (e.key === 'ArrowLeft') n = (i - 1 + self.tabs.length) % self.tabs.length;
        if (e.key === 'Home') n = 0;
        if (e.key === 'End') n = self.tabs.length - 1;
        if (n === null) return;
        e.preventDefault();
        self.select(self.tabs[n].getAttribute('data-alc-mtab'), true);
      });
    });
    // swipe sideways on the menu body to change tab
    var x0 = null, y0 = 0;
    if (this.body) {
      this.body.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      this.body.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy) * 1.8) return;
        var i = self.index();
        var n = dx < 0 ? i + 1 : i - 1;
        if (n >= 0 && n < self.tabs.length) self.select(self.tabs[n].getAttribute('data-alc-mtab'), false);
      }, { passive: true });
    }
    // fresh on every open: default tab, top of the list, rows ease in
    if (this.details) {
      this.details.addEventListener('toggle', function () {
        if (self.details.open) { self.select(self.def, false, true); self.animate(); }
      });
    }
  }
  PhoneMenu.prototype.index = function () {
    for (var i = 0; i < this.tabs.length; i++) if (this.tabs[i].classList.contains('is-active')) return i;
    return 0;
  };
  PhoneMenu.prototype.select = function (key, focus, quiet) {
    var found = this.tabs.some(function (t) { return t.getAttribute('data-alc-mtab') === key; });
    if (!found) key = this.tabs.length ? this.tabs[0].getAttribute('data-alc-mtab') : key;
    var changed = false;
    this.tabs.forEach(function (t) {
      var on = t.getAttribute('data-alc-mtab') === key;
      if (on && !t.classList.contains('is-active')) changed = true;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      if (on && focus) t.focus();
    });
    this.panels.forEach(function (p) { p.hidden = p.getAttribute('data-alc-mpanel') !== key; });
    if (this.body) this.body.scrollTop = 0;
    var locale = this.el.querySelector('[data-alc-locale]');
    if (locale && locale.__alcLocale) locale.__alcLocale.close();
    if (changed && !quiet) this.animate();
  };
  PhoneMenu.prototype.animate = function () {
    if (reduceMotion) return;
    var el = this.el;
    var panel = el.querySelector('[data-alc-mpanel]:not([hidden])');
    if (!panel) return;
    var items = panel.querySelectorAll('.alc-m__card, .alc-tiles__head, .alc-tile, .alc-m__row, .alc-m__social');
    Array.prototype.forEach.call(items, function (it, i) {
      it.setAttribute('data-alc-anim', '');
      it.style.setProperty('--i', Math.min(i, 12));
    });
    el.classList.remove('is-animating');
    void el.offsetWidth;
    el.classList.add('is-animating');
    clearTimeout(this.animTimer);
    this.animTimer = setTimeout(function () { el.classList.remove('is-animating'); }, 1100);
  };
  function initPhoneMenus(root) {
    (root || document).querySelectorAll('[data-alc-mmenu]').forEach(function (el) {
      if (el.__alcPhoneMenu) return;
      el.__alcPhoneMenu = new PhoneMenu(el);
    });
  }

  /* ---------------------------------------------------------------- prices in the visitor's currency
     Prices that come from Shopify (product, Ritual and cart prices) already follow the visitor's
     currency. Some older sections write amounts as plain US-dollar text: the $78 Welcome Kit, the
     $28 / $32 / $18 gift values and the $75 free-shipping line. For visitors in another currency
     those are swapped for the real values from snippets/alcami-money-data.liquid (kit and gifts) or
     converted at Shopify's rate and rounded (other amounts). */
  var money = null;
  var KIT_RE = /(?:[A-Z]{1,3})?[$€£]\s?78(?:[.,]00)?(?!\d)/g;
  var USD_RE = /\$\s?(\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{2})?(?!\d)/g;
  function moneyData() {
    if (money) return money;
    var el = document.getElementById('AlcMoney');
    try { money = el ? JSON.parse(el.textContent) : {}; } catch (e) { money = {}; }
    return money;
  }
  function fmtWhole(n) {
    var m = moneyData();
    var sample = m.fmt || '$1,234.56';
    var sep = (sample.match(/1(\D?)234/) || [0, ','])[1];
    var digits = String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return (m.fmt0 || '$1').replace('1', digits);
  }
  function eachText(el, fn) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(fn);
  }
  // assets/custom.js writes the gift values in US dollars whenever the bundle size changes
  // ($28, $56, $84 for the tumbler), so these are converted again after every rewrite. A multiple of
  // the base value uses the real price in the visitor's currency (whole units) times the multiple.
  var GIFT_USD = { tumbler: 28, frother: 32, spoon: 18 };
  function convertWatched(el, base, unit, rate) {
    var t = el.textContent;
    if (t === el.__alcOut) return;
    var a = t.match(/\$\s?(\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{2})?(?!\d)/);
    if (!a) return;
    var amount = parseFloat(a[1].replace(/,/g, ''));
    var n = base ? amount / base : 0;
    var val = unit && n > 0 && n === Math.round(n) ? unit * n : amount * rate;
    if (!val) return;
    el.__alcOut = t.replace(a[0], fmtWhole(val));
    el.textContent = el.__alcOut;
  }
  function watchAmount(el, base, unit, rate) {
    convertWatched(el, base, unit, rate);
    if (el.__alcWatch) return;
    el.__alcWatch = true;
    new MutationObserver(function () { convertWatched(el, base, unit, rate); })
      .observe(el, { childList: true, characterData: true, subtree: true });
  }
  // The Welcome Kit is the same for every bundle size: one tumbler, one frother and one spoon.
  // custom.js multiplies the gift values by the bundle size ($56 / $64 / $36 for a Double Ritual,
  // $84 / $96 / $54 for a Triple), so every rewrite is pinned back to the single-item value, in the
  // visitor's currency (17 Oct, Carlos: "we are giving the same gifts").
  var MONEY_TOKEN = /(?:[A-Z]{1,3})?[$€£]\s?\d[\d.,\s]*\d|(?:[A-Z]{1,3})?[$€£]\s?\d/;
  function pinGift(el, whole) {
    if (!whole) return;
    var fix = function () {
      var t = el.textContent;
      if (t === el.__alcPin) return;
      if (!MONEY_TOKEN.test(t)) return;
      el.__alcPin = t.replace(MONEY_TOKEN, fmtWhole(whole));
      el.textContent = el.__alcPin;
    };
    fix();
    if (el.__alcPinWatch) return;
    el.__alcPinWatch = true;
    new MutationObserver(fix).observe(el, { childList: true, characterData: true, subtree: true });
  }
  function pinGifts(root) {
    var m = moneyData();
    var gc = m.gc || {};
    var unit = function (key) { return gc[key] ? Math.round(gc[key] / 100) : (!m.cur || m.cur === m.shop ? GIFT_USD[key] : 0); };
    root.querySelectorAll('.hero_gift_was').forEach(function (el) {
      var col = el.closest('.hero_gift_col');
      var name = (col ? col.textContent : '').toLowerCase();
      var key = /tumbler/.test(name) ? 'tumbler' : /frother/.test(name) ? 'frother' : /spoon/.test(name) ? 'spoon' : '';
      if (key) pinGift(el, unit(key));
    });
    var kit = unit('tumbler') + unit('frother') + unit('spoon');
    var subsKit = document.getElementById('subs_gift_value');
    if (subsKit && kit) pinGift(subsKit, kit);
  }
  // Free shipping on one-time orders (17 Oct): from $75 in the US, CA$99 in Canada and US$99
  // everywhere else. The copy is written as "$75", so visitors outside the US see their own rule.
  function freeShipAmount(m, rate) {
    var country = (window.Shopify && Shopify.country) || '';
    if (!country || country === 'US') return 0;
    if (m.cur === 'CAD') return 99;
    if (!m.cur || m.cur === m.shop) return 99;
    return rate ? 99 * rate : 0;
  }
  function fixFreeShip(root, to) {
    if (!to) return;
    root.querySelectorAll('.apm-trust__item, .apm-ac__body, .afq-a__inner, [data-alc-usd-text]').forEach(function (el) {
      eachText(el, function (n) {
        if (/\$\s?75(?:\.00)?(?!\d)/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/\$\s?75(?:\.00)?(?!\d)/g, fmtWhole(to));
      });
    });
  }
  function fixPrices(root) {
    var m = moneyData();
    root = root || document;
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 0;
    pinGifts(root);
    var fs = freeShipAmount(m, rate);
    if (!m.cur || !m.shop || m.cur === m.shop) { fixFreeShip(root, fs); return; }
    var usd = function (s, a) {
      var v = parseFloat(a.replace(/,/g, ''));
      if (fs && v === 75) return fmtWhole(fs);
      return fmtWhole(v * rate);
    };
    if (m.kit) {
      root.querySelectorAll('.hero_pick_heading, .art-note__txt, .ahq-q__tag, [data-alc-kit-text]').forEach(function (el) {
        if (el.__alcKit) return;
        el.__alcKit = true;
        eachText(el, function (n) { n.nodeValue = n.nodeValue.replace(KIT_RE, m.kit); });
      });
      var rootEl = document.documentElement;
      var note = getComputedStyle(rootEl).getPropertyValue('--alat-kit-note');
      if (note && !rootEl.__alcKitNote && KIT_RE.test(note)) {
        rootEl.__alcKitNote = true;
        rootEl.style.setProperty('--alat-kit-note', note.trim().replace(KIT_RE, m.kit));
      }
      KIT_RE.lastIndex = 0;
    }
    // gift tiles and the kit total are pinned by pinGifts() above
    var oneKit = document.getElementById('gift_value');
    if (oneKit) watchAmount(oneKit, 0, 0, rate);
    if (rate) {
      root.querySelectorAll('.apm-trust__item, .apm-ac__body, .afq-a__inner, [data-alc-usd-text]').forEach(function (el) {
        if (el.__alcUsd) return;
        el.__alcUsd = true;
        eachText(el, function (n) { if (USD_RE.test(n.nodeValue)) { USD_RE.lastIndex = 0; n.nodeValue = n.nodeValue.replace(USD_RE, usd); } USD_RE.lastIndex = 0; });
      });
    }
  }

  /* ---------------------------------------------------------------- delivery date in the cart and buy box
     "Get it by Thu, Nov 5". Since 3 Nov 2026 (Carlos) the rule is simple: data-days (3) calendar days
     with today counted as the first day, so the date is today + 2. No weekend, holiday or cutoff-hour
     rules. "Today" is the date in data-tz. Only for the countries in data-countries.
     Markup: snippets/mini-cart.liquid and snippets/alcami-bb-cta.liquid. */
  var ETA_TEXT = {
    en: 'Get it by <b>{d}</b>',
    fr: 'Livraison prévue le <b>{d}</b>',
    es: 'Recíbelo el <b>{d}</b>'
  };
  function etaFor(days, tz) {
    var p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    // today is day 1
    return new Date(Date.UTC(+p.year, +p.month - 1, +p.day + Math.max(days, 1) - 1));
  }
  function fillEta(root) {
    (root || document).querySelectorAll('[data-alc-eta]').forEach(function (el) {
      var country = (window.Shopify && Shopify.country) || '';
      var allowed = (el.getAttribute('data-countries') || 'US,CA').split(',');
      if (!country || allowed.indexOf(country) < 0) { if (!el.hidden) el.hidden = true; return; }
      try {
        var days = parseInt(el.getAttribute('data-days'), 10) || 3;
        var tz = el.getAttribute('data-tz') || 'America/Montreal';
        var lang = (document.documentElement.lang || 'en').slice(0, 2);
        var d = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }).format(etaFor(days, tz));
        var mainHtml = (ETA_TEXT[lang] || ETA_TEXT.en).replace('{d}', d);
        var main = el.querySelector('[data-alc-eta-main]');
        var sub = el.querySelector('[data-alc-eta-sub]');
        // only touch the DOM when something changed (the cart watcher reacts to every change)
        if (main && main.innerHTML !== mainHtml) main.innerHTML = mainHtml;
        if (sub && sub.textContent !== '') sub.textContent = '';
        if (el.hidden) el.hidden = false;
      } catch (e) { if (!el.hidden) el.hidden = true; }
    });
  }
  // the cart drawer re-renders its contents after every change: fill the date again
  function watchCart() {
    var mc = document.getElementById('mini-cart');
    if (!mc || mc.__alcEta) return;
    mc.__alcEta = true;
    new MutationObserver(function () { fillEta(mc); }).observe(mc, { childList: true, subtree: true });
  }

  /* ---------------------------------------------------------------- announcement bar */
  function initAnnounce(root) {
    (root || document).querySelectorAll('[data-alc-announce]').forEach(function (bar) {
      if (bar.__alcAnn) return;
      bar.__alcAnn = true;
      var slides = Array.prototype.slice.call(bar.querySelectorAll('[data-alc-ann-slide]'));
      if (slides.length < 2) return;
      var i = 0, timer = 0, paused = false;
      var wait = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
      var show = function (n) {
        var cur = slides[i];
        i = (n + slides.length) % slides.length;
        var next = slides[i];
        if (cur === next) return;
        cur.classList.remove('is-active');
        cur.classList.add('is-leaving');
        cur.setAttribute('aria-hidden', 'true');
        cur.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
        setTimeout(function () { cur.classList.remove('is-leaving'); }, 460);
        next.classList.add('is-active');
        next.removeAttribute('aria-hidden');
        next.querySelectorAll('a').forEach(function (a) { a.removeAttribute('tabindex'); });
      };
      var schedule = function () {
        clearTimeout(timer);
        if (reduceMotion || paused || document.hidden) return;
        timer = setTimeout(function () { show(i + 1); schedule(); }, wait);
      };
      var prev = bar.querySelector('[data-alc-ann-prev]');
      var next = bar.querySelector('[data-alc-ann-next]');
      if (prev) prev.addEventListener('click', function () { show(i - 1); schedule(); });
      if (next) next.addEventListener('click', function () { show(i + 1); schedule(); });
      bar.addEventListener('mouseenter', function () { paused = true; clearTimeout(timer); });
      bar.addEventListener('mouseleave', function () { paused = false; schedule(); });
      bar.addEventListener('focusin', function () { paused = true; clearTimeout(timer); });
      bar.addEventListener('focusout', function () { paused = false; schedule(); });
      document.addEventListener('visibilitychange', schedule);
      // swipe on phones
      var x0 = null;
      bar.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      bar.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) { show(dx < 0 ? i + 1 : i - 1); schedule(); }
      }, { passive: true });
      schedule();
    });
  }

  /* ---------------------------------------------------------------- loader
     assets/custom.js shows a loader while a product and its gifts are added (over the page) and
     while the cart updates (inside the drawer). Both draw their content with the global
     alcamiLoaderMarkup(); it is replaced here, so both show the ALCAMI wordmark filling with latte
     (Carlos picked "Wordmark pour", 17 Oct). Styles: assets/alcami-pages.css, section 8. */
  var wmCount = 0;
  function wordmarkLoader(msg) {
    var id = 'alcWm' + (++wmCount);
    var txt = 'x="100" y="54" text-anchor="middle" font-family="Anton, \'Alcami Anton Fallback\', Impact, sans-serif" font-size="58" letter-spacing="2"';
    return '<div class="acl-inner acl-v2">' +
      '<svg class="acl-wm" viewBox="0 0 200 62" aria-hidden="true" focusable="false">' +
        '<defs><clipPath id="' + id + '"><text ' + txt + '>ALCAMI</text></clipPath>' +
        '<linearGradient id="' + id + 'g" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#D9A86C"/><stop offset="1" stop-color="#A86E38"/></linearGradient></defs>' +
        '<text class="acl-wm__ghost" ' + txt + '>ALCAMI</text>' +
        '<g clip-path="url(#' + id + ')"><g class="acl-wm__fill"><path class="acl-wm__wave" d="M0 6Q20 0 40 6T80 6T120 6T160 6T200 6T240 6T280 6V80H0Z" fill="url(#' + id + 'g)"/></g></g>' +
      '</svg>' +
      '<div class="acl-msg" role="status" aria-live="polite">' + (msg || 'Adding to your ritual') + '</div>' +
    '</div>';
  }
  function initLoader() {
    try { window.alcamiLoaderMarkup = function () { return wordmarkLoader(); }; } catch (e) {}
    document.querySelectorAll('.alcami-page-loader, .alcami-cart-loader').forEach(function (el) {
      if (el.querySelector('.acl-v2')) return;
      el.innerHTML = wordmarkLoader();
    });
  }

  /* ---------------------------------------------------------------- init */
  function init(root) {
    initLoader();
    initMenus(root);
    initLocales(root);
    initPhoneMenus(root);
    initAnnounce(root);
    fixPrices(root);
    fillEta(root);
    watchCart();
    syncOffsets();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAllMenus(); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('load', function () { syncOffsets(); initLoader(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
